import React, { useRef } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import {
  chunkArray,
  convertStringToArray,
  sanitizeString,
} from "../../Utils/utils";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { imageUrl } from "../../constants/constants";
import SliderNavigation from "../SliderNavigation";

const LatestNews = () => {
  const navigate = useNavigate();
  const { languageType } = useSelector((state) => state.homeSlice);
  const slider = useRef();

  const { data: latestNewsData = [], isLoading: latestNewsIsLoading } =
    useGetProtectedApiDataQuery({ url: "latest_news", lang: languageType });
  const { getText } = useLanguageTranslation();

  // const transformedData = latestNewsData.map((item) => ({
  //   ...item,
  //   field_upload_image: convertStringToArray(item.field_upload_image),
  // }));

  // const transformedLatestNewsData = chunkArray(transformedData, 4);

  const transformedLatestNewsData = chunkArray(
    latestNewsData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    })),
    4,
  );

  const settings = {
    dots: false,
    // infinite: true,
    infinite: transformedLatestNewsData.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    autoplay: transformedLatestNewsData.length > 1,
    autoplaySpeed: 3000,
    pauseOnHover: true,
  };

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };

  const handlePhotoClick = (nid) => {
    navigate(`/latest-news-detail/${nid}`);
  };

  if (latestNewsIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="col-12 col-sm-12 col-md-8 col-lg-8 latest-news">
        <div className="title-sec">
          <h2>{getText("Latest News", "नवीनतम समाचार")}</h2>
          <SliderNavigation slider={slider} section={"latest news"} />
        </div>
        <div>
          <Slider {...settings} ref={slider}>
            {transformedLatestNewsData.map((item, index) => (
              <div className="latest-news-box" key={index}>
                <div className="row">
                  {item.map((subItem, index) => {
                    const title = sanitizeString(subItem.title);
                    const desc = sanitizeString(subItem.body);
                    return (
                      <div
                        className="col-12 col-sm-12 col-md-6 col-lg-6 print-news"
                        key={index}
                      >
                        <div
                          className="card-sec wow zoomIn"
                          onClick={() => handlePhotoClick(subItem.nid)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="img-sec">
                            <img
                              alt={title}
                              src={
                                subItem?.field_upload_image?.[0]?.file_path
                                  ? imageUrl +
                                    subItem.field_upload_image[0].file_path
                                  : "images/dummy.png"
                              }
                            />
                          </div>
                          <div className="desc-sec">
                            <span className="date">
                              {subItem?.field_ordering_date}
                            </span>
                            <a
                              href="#"
                              onClick={(e) => e.preventDefault()}
                              className="line-clamp line-clamp-1"
                            >
                              {/* {title.length > 60
                                ? `${title.slice(0, 60)} ...`
                                : title} */}
                              {title}
                            </a>
                            <p className="line-clamp line-clamp-5">
                              {/* {desc.length > 200
                                ? `${desc.slice(0, 200)} ...`
                                : desc} */}
                              {desc}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/latest-news-detail");
          }}
          className="quick-btn"
          aria-label={"View all latest news"}
        >
          {getText("View All", "सभी देखें")}
        </a>
      </div>
    </>
  );
};

export default LatestNews;
